<template>
  <section>
    <div
      v-for="(item, index) in items"
      :key="index"
      class="matrix-item"
      :class="{
        'mb-5 sm:mb-8 md:mb-10 xl:mb-12 2xl:mb-16': $route.meta.style === 'lid',
        'relative grid grid-cols-12': $route.meta.style === 'db',
        'margin-bottom-page-content-with-content-items-following': index !== items.length - 1 && !isNonCard(item) && !isNonCard(items[index + 1]) && $route.meta.style === 'db',
        'margin-bottom-page-content-without-content-items-following':
          index !== items.length - 1 && !isNonCard(item) && items[index + 1]?.__typename === 'neo_linkBlocks_BlockType' && $route.meta.style === 'db',
        'container mx-auto px-4':
          (item.__typename === 'neo_cookieDeclaration_BlockType' ||
            item.__typename === 'neo_donationIframe_BlockType' ||
            item.__typename === 'neo_externalForm_BlockType' ||
            item.__typename === 'neo_image_BlockType' ||
            item.__typename === 'neo_imageCarousel_BlockType' ||
            item.__typename === 'neo_issuu_BlockType' ||
            item.__typename === 'neo_kentaaWidget_BlockType' ||
            item.__typename === 'neo_linkBlocks_BlockType' ||
            item.__typename === 'neo_questionanswers_BlockType' ||
            item.__typename === 'neo_quote_BlockType' ||
            item.__typename === 'neo_form_BlockType' ||
            item.__typename === 'neo_rawText_BlockType' ||
            item.__typename === 'neo_text_BlockType') &&
          $route.meta.style === 'db',
        'last-content-item-not-rounded': index === items.length - 1 && enableLastItemRounded && $route.meta.style === 'db',
      }"
      :style="{ 'z-index': 30 - index }"
    >
      <LazyMoleculeMatrixBanner
        v-if="item.__typename === 'neo_banner_BlockType' && item.bannerReference"
        :title="item.bannerReference.title"
        :subtitle="item.bannerReference.subtitle"
        :introduction="item.bannerReference.introduction"
        :image="item.bannerReference.image"
        :primary-button-label="item.bannerReference.primaryButtonLabel"
        :primary-button-url="item.bannerReference.primaryButtonUrl"
        :secondary-button-label="item.bannerReference.secondaryButtonLabel"
        :secondary-button-url="item.bannerReference.secondaryButtonUrl"
        class="col-span-full mt-16 sm:mt-16"
        :class="{ 'mb-12 sm:mb-16': index !== items.length - 1 }"
      />
      <LazyMoleculeMatrixDonationIframe
        v-if="item.__typename === 'neo_donationIframe_BlockType'"
        id="matrix-iframe-donation-form"
        :url="item.donationIframeUrl || get(item, 'donationReference.donationIframeUrl')"
        class="padding-page-content"
        :class="{ 'db-content-item-inside-grid': $route.meta.style === 'db' }"
      />
      <LazyMoleculeMatrixExternalForm
        v-if="item.__typename === 'neo_externalForm_BlockType'"
        :external-form="item.externalForm"
        class="padding-page-content"
        :class="{ 'db-content-item-inside-grid': $route.meta.style === 'db' }"
      />
      <LazyMoleculeMatrixForm
        v-if="item.__typename === 'neo_form_BlockType'"
        :handle="item.form.handle"
        :expiry-date="expiryDate"
        class="padding-page-content"
        :class="{ 'db-content-item-inside-grid': $route.meta.style === 'db' }"
      />
      <LazyMoleculeMatrixImage
        v-if="item.__typename === 'neo_image_BlockType'"
        :image="item.image"
        class="padding-page-content"
        :class="{ 'db-content-item-inside-grid': $route.meta.style === 'db' }"
      />
      <LazyMoleculeMatrixImageCarousel
        v-if="item.__typename === 'neo_imageCarousel_BlockType'"
        :entries="item.entries"
        class="padding-page-content"
        :class="{ 'db-content-item-inside-grid': $route.meta.style === 'db' }"
      />
      <LazyMoleculeMatrixIssuu
        v-if="item.__typename === 'neo_issuu_BlockType'"
        :title="item.title"
        :url="item.url"
        class="padding-page-content"
        :class="{ 'db-content-item-inside-grid': $route.meta.style === 'db' }"
      />
      <LazyMoleculeMatrixKentaaIframe
        v-if="item.__typename === 'neo_kentaaWidget_BlockType'"
        :kentaa-widget-id="item.kentaaWidgetId"
        :kentaa-widget-url="item.kentaaWidgetUrl"
        class="padding-page-content"
        :class="{ 'db-content-item-inside-grid': $route.meta.style === 'db' }"
      />
      <LazyMoleculeMatrixQuestionAnswers
        v-if="item.__typename === 'neo_questionanswers_BlockType'"
        :title="item.title"
        :entries="item.entries"
        class="padding-page-content"
        :class="{ 'db-content-item-inside-grid': $route.meta.style === 'db' }"
      />
      <LazyMoleculeMatrixQuote
        v-if="item.__typename === 'neo_quote_BlockType'"
        :source="item.source"
        :quote="item.quote"
        :role="item.role"
        :image="item.image"
        class="padding-page-content"
        :class="{ 'db-content-item-inside-grid': $route.meta.style === 'db' }"
      />
      <LazyMoleculeMatrixRawText
        v-if="item.__typename === 'neo_rawText_BlockType'"
        :raw-text="item.rawText"
        class="padding-page-content"
        :class="{ 'db-content-item-inside-grid': $route.meta.style === 'db' }"
      />
      <LazyMoleculeMatrixText
        v-if="item.__typename === 'neo_text_BlockType'"
        :text="item.description"
        class="padding-page-content"
        :class="{ 'db-content-item-inside-grid': $route.meta.style === 'db' }"
      />
      <LazyMoleculeMatrixLinkBlocks
        v-if="item.__typename === 'neo_linkBlocks_BlockType'"
        :title="item.title"
        :ctas="item.entries"
        class="!bg-opacity-0"
        :class="{
          'db-content-item-inside-grid xl:!col-start-2 xl:!col-end-12 2xl:!col-start-2 2xl:!col-end-12': $route.meta.style === 'db',
          'margin-bottom-page-content-without-content-items-following': index !== items.length - 1 && $route.meta.style === 'db',
        }"
      />
      <LazyMoleculeMatrixCookieDeclaration
        v-if="item.__typename === 'neo_cookieDeclaration_BlockType'"
        :cookiebot-id="item.cookiebotId"
        class="padding-page-content"
        :class="{ 'db-content-item-inside-grid': $route.meta.style === 'db' }"
      />
    </div>
  </section>
</template>

<script setup lang="ts">
import { useRoute } from 'vue-router'
import get from 'lodash/get'

interface Props {
  items: any[] // Assuming any type, replace with specific type if known
  enableLastItemRounded?: boolean
  expiryDate?: string
}

defineProps<Props>()
const $route = useRoute()

// Items that do not render a rounded white card and therefore cannot absorb
// the negative-margin overlap that successive card items rely on.
const NON_CARD_TYPENAMES = ['neo_banner_BlockType', 'neo_linkBlocks_BlockType']
const isNonCard = (item: any) => NON_CARD_TYPENAMES.includes(item?.__typename)
</script>

<style lang="scss" scoped>
.db-content-item-inside-grid {
  @apply col-span-full relative bg-white rounded-xl lg:col-start-2 lg:col-end-12 xl:col-start-3 xl:col-end-11 2xl:col-start-4 2xl:col-end-10;

  .last-content-item-not-rounded & {
    @apply rounded-b-none;
  }
}
</style>
